import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyB0EOdxZqtZG53PuTV32_FURH9GwnyLOZw",
  authDomain: "feed-5070d.firebaseapp.com",
  projectId: "feed-5070d",
  storageBucket: "feed-5070d.firebasestorage.app",
  messagingSenderId: "344527563994",
  appId: "1:344527563994:web:8a746064531e3a29f409e3",
  measurementId: "G-CFYN2Z1SHF"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Export initialized services
export { db, auth, googleProvider }; 